import React from "react";
import "./style.scss";
import usePolicyText from "../../hooks/usePolicyText";
import LegalMaterial from "../../components/LegalMaterial";

export default function ConditionsNew() {
  // t — из хука с пином EN (см. usePolicyText): страница EN-only by design
  const { t, renderTwoLevelParagraph } = usePolicyText("en");

  return (
    <LegalMaterial header={t("new_condition_title")}>
      <div className="conditions-page">
        <div className="conditions-page__content">
          {renderTwoLevelParagraph("new_condition_1")}
          {renderTwoLevelParagraph("new_condition_2")}
          {renderTwoLevelParagraph("new_condition_3")}
          {renderTwoLevelParagraph("new_condition_4")}
          {renderTwoLevelParagraph("new_condition_5")}
          {renderTwoLevelParagraph("new_condition_6")}
          {renderTwoLevelParagraph("new_condition_7")}
          {renderTwoLevelParagraph("new_condition_8")}
          {renderTwoLevelParagraph("new_condition_9")}
          {renderTwoLevelParagraph(
            "new_condition_10",
            "new_condition_10_1",
            true
          )}
        </div>
      </div>
    </LegalMaterial>
  );
}
